import axios from 'axios';

const API_BASE = '/api/parts';

export const partService = {
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  getNextNumber: async () => {
    const response = await axios.get(`${API_BASE}/next-number`);
    return response.data;
  },

  getCategories: async () => {
    const response = await axios.get(`${API_BASE}/categories/list`);
    return response.data;
  },

  removeCategory: async (name) => {
    const response = await axios.delete(
      `${API_BASE}/categories/${encodeURIComponent(name)}`
    );
    return response.data;
  },

  getLabels: async () => {
    const response = await axios.get(`${API_BASE}/labels`);
    return response.data;
  },

  createLabel: async (data) => {
    const response = await axios.post(`${API_BASE}/labels`, data);
    return response.data;
  },

  updateLabel: async (id, data) => {
    const response = await axios.put(`${API_BASE}/labels/${id}`, data);
    return response.data;
  },

  removeLabel: async (id) => {
    const response = await axios.delete(`${API_BASE}/labels/${id}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  },

  convertToService: async (id, body = {}) => {
    const response = await axios.post(`${API_BASE}/${id}/convert-to-service`, body);
    return response.data;
  }
};
